import React from "react";
import { Dropdown } from 'primereact/dropdown';
import './InputLista.scss'
const InputLista = ({value,onChange,options,placeholder,disabled=false,titulo,optionLabel='name',id,className})=>
{
    return(
        <div className={`InputLista ${className}`}>
            <div className="contenedorTitulo">
                <div className="obligatorio"> * </div>
                <div className="titulo">{titulo}</div>
            </div>
            <Dropdown className="lista" disabled={disabled} id={id} value={value} onChange={onChange} options={options} optionLabel={optionLabel} placeholder={placeholder} filter 
            ></Dropdown>
        </div>
    )
}
export default InputLista